import React from 'react';
import Container from './container';
import { BrowserRouter } from 'react-router-dom';
import Raven from 'raven-js';

Raven.config(process.env.REACT_APP_SENTRY_DSN).install();

class App extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <Container />
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js